import { makeStyles } from "@material-ui/core/styles";
import canvasImage from '../images/canvas.jpg'

export const useStyles = makeStyles((theme) => ({
    margin:{},
    header: {
        backgroundColor: "#ffffff",
        height: "auto",
        width: "100%",
        padding: 15
    },
    headerTitle: {
        fontSize: "20px",
        fontWeight: 900,
        marginBottom: 10,
        marginLeft: 10
    },
    headerSubTitle: {
        fontSize: "15px",
        color: "#8a8a8a",
        marginLeft: 10
    },

    dragDrop: {
        display: "flex",
        flexDirection: 'row',
    },
    dragdropComponent: {
        display: 'flex',
        flexDirection: "row",
        width: '100%',
        borderTop: "rgb(241,242,246) solid 2px"
    },
    columns: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        justifyContent: 'space-between',
        padding: 20,
        width: "350px",
        // backgroundColor:"#f1f2f6",
    },
    colName: {
        color: "#848484",
        fontWeight: 500,
        fontSize: "14px"
    },
    dragtext: {
        color: "#848484",
        fontWeight: 500,
        fontSize: "14px",
        marginTop: "16px"
    },
    dragged: {
        backgroundColor: "red",
        width: "100%",
        height: 200
    },
    groupandtable: {
        overflow: 'auto',
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    dragHere: {
        backgroundImage: `url(${canvasImage})`,
        textAlign: 'center',
        padding: 0,
        // backgroundColor:"#ffffff",
        height: '50%',
        width: "auto",
        marginBottom: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: "column"

    },
    dragHereUpdated: {
        backgroundImage: `url(${canvasImage})`,
        textAlign: 'center',
        padding: 0,
        // backgroundColor:"#ffffff",
        height: '50%',
        width: "auto",
        marginBottom: 10,
    },
    /* blank: {
        display: 'flex',
        width: '200px',
        // backgroundColor: '#f1f2f6',
        backgroundColor: 'black',
        padding: '13px',
        margin: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50px',
    }, */
    blank: {
        display: 'flex',
        flexDirection: 'row',
        height: 'auto',
        // justifyContent: 'space-between',
        // flexWrap:'wrap',
        padding: '24px',
        margin: '8px',
        backgroundColor: '#f1f2f6',
        marginLeft: '30px',
        marginRight: '30px',
    },
    dragdropLabelTitle: {
        fontWeight: 500,
        fontSize: 20,
        paddingTop: "10px"
    },
    dragdropsubTitleLabel: {
        // margin:30,
        fontSize: 14,
        color: "#8a8a8a"
    },
    componentSearch: {
        // marginTop: '20px',
        "& .MuiInputBase-root": {
            fontSize: '13px',
            height: '38px',
            width: '280px',
            borderRadius: '30px',
            borderBottom: 'none',
            border: "unset",
            paddingLeft: '20px',
        }
    },
    componentsList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'auto',
        // backgroundColor: 'rgb(203, 203, 203)',
        margin: '10px',
        padding: '20px',
        width: 'auto',
        height: '519px'
    },
    draggedComponents: {
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'row',
        height: 'auto',
        // justifyContent: 'space-between',
        // flexWrap:'wrap',
        padding: '1rem',
        margin: '2px',
        // width:'auto',
        // "& span": {
        //     backgroundColor: '#fffbec',
        //     boxShadow: '0px 1.7px 4px -1px #000000',
        //     marginLeft: '30px',
        //     marginRight: '30px',
        // },
        // "& div div": {
        //     backgroundColor: '#f1f2f6',
        //     marginLeft: '30px',
        //     marginRight: '30px',
        // }
    },
    
    components: {
        display: 'flex',
        width: '200px',
        //backgroundColor: '#ffffff',
        padding: '13px',
        borderRadius: '4px',
        margin: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50px',
        fontWeight: 800,
        backgroundColor: '#fffbec',
        boxShadow: '0px 1.7px 4px -1px #000000',
        marginLeft: '30px',
        marginRight: '30px',
        cursor: "grab"
    },
    //pagination //
    paginationCount: {
        "& .MuiInputBase-root": {
            width: 60,
        }
    },
    footer: {
        display: 'flex',
        backgroundColor: "#ffffff",
        height: "auto",
        width: "100%",
        padding: 15,
        boxShadow: '0px 0px 10px -1px #000000',
    },
    viewNameTextField: {
        "& .MuiInputBase-root": {
            borderRadius: "5px",
            height: '48px',
            width: '450px',
            [theme.breakpoints.down("md")]: {
                width: "300px",
            },
            backgroundColor: '#f1f2f6',
            marginRight: '30px',
            padding: '8px'
        }
    },
    viewNameTextFieldAdd: {
        "& .MuiInputBase-root": {
            borderRadius: "5px",
            height: '48px',
            width: '450px',
            [theme.breakpoints.down("md")]: {
                width: "300px",
            },
            backgroundColor: '#ffe6e6',
            marginRight: '30px',
            padding: '8px',
            border: "1px solid #ffb0b0",
            color: "#ff0d0d"
        }
    },
    createButton: {
        fontSize: '20px',
        height: "48px",
        width: '165px',
        [theme.breakpoints.down("md")]: {
            width: "90px",
        },
        marginRight: '30px'
    },
    cancelColumn: {
        position: "relative",
    },
    columnContainer: {
        "&:hover div": {
            display: 'block !important',
        }
    },
    closeFieldIcon: {
        position: "absolute",
        right: "34px",
        top: "24px",
    },
    componentsField: {
        display: 'flex',
        width: '200px',
        backgroundColor: '#ffffff',
        padding: '13px',
        borderRadius: '4px',
        margin: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50px',
        fontWeight: 800,
        cursor: "grab"
    },
    dragging: {
        cursor: "-webkit-grabbing",
        //cursor: "grabbing"
    },
    settingData: {
        "& .MuiTypography-body1": {
            fontWeight: 500,
        },
    }
}));


